import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { LaneTicker } from "@/components/LaneTicker";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { DigitalPresence } from "@/components/DigitalPresence";
import { Pricing } from "@/components/Pricing";
import { Process } from "@/components/Process";
import { CtaBanner } from "@/components/CtaBanner";
import { Faq } from "@/components/Faq";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-[#0B0B0B] text-white font-body" data-testid="landing-page">
      <Nav />
      <Hero />
      <LaneTicker />
      <Marquee />
      <Manifesto />
      <Services />
      <DigitalPresence />
      <Pricing />
      <Process />
      <CtaBanner />
      <Faq />
      <ContactForm />
      <Footer />
    </div>
  );
}
